<div class="bg-th-blue mt-0 container-fluid py-2">

    <div class=" d-flex justify-content-between align-content-center">

        <i class="fa fa-arrow-left text-white my-auto pointer" 
        
            [routerLink]="['/carInfo', mdlTempAccess.get('strUnitID')?.value]"> 
            
        </i>

        <a class="text-white f18 my-auto dirI d-flex align-items-center">
            
            دسترسی های موقت
        
        </a>

    </div>

</div>

<main class="container-xxl">

    <section class="border border-2 p-2 mt-4 dirI" style="max-height: 85vh;">

        <form class="w-100 row gx-2 gy-3 gy-md-0 p-2">

            <div class="col-12 col-md-11">

                <input type="text" class="w-100 my-3 form-control" placeholder="جستجو کنید...." (keyup)="filter_list($event.target)">

            </div>

            <div class="col-12 col-md-1 d-flex align-items-center">
    
                <button class="btn w-100 px-3 btn-primary" (click)="openModal(false)"> 
                    
                    افزودن
                
                </button>
        
            </div>

        </form>

        <div class="section">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">
    
                <thead>
        
                    <tr class="">
        
                        <th class="text-center col-1"> # </th>
    
                        <th class="text-center"> عملیات </th>
            
                        <th class="text-center"> زمان ایجاد  </th>
    
                        <th class="text-center"> ایجاد کننده </th>
        
                        <th class="text-center"> موبایل(کاربری)  </th>
                        
                        <th class="text-center"> تاریخ شروع  </th>

                        <th class="text-center"> زمان شروع </th>
        
                        <th class="text-center"> تاریخ پایان  </th>
                
                        <th class="text-center"> زمان پایان  </th>
        
                        <th class="text-center"> آخرین استفاده </th>
        
                    </tr>
                    
                </thead>
    
                <tbody>
    
                    <tr *ngFor="let item of list_Result; let i=index" style="vertical-align: middle;">
    
                        <td class="col-1 text-center"> {{ i + 1 | faNum }} </td>
    
                        <td class="col-2 text-center">
    
                            <i title="ویرایش" 
                            
                                class="fa fa-pencil-square my-2 my-md-0
                            
                                fa-lg bg-gray p-2 rounded text-primary pointer" 
                                
                                (click)="openModal(true,item)" 
                                
                                aria-hidden="true">
                            
                            </i>
    
                            <i title="پیامک لینک به موبایل کاربر" 
                            
                                class="fa fa-envelope mx-2 my-2 my-md-0
                            
                                fa-lg bg-gray p-2 rounded text-success pointer"
                                
                                (click)="openSmsModal(item)" 
                                
                                aria-hidden="true">
                            
                            </i>
    
                            <i title="حذف" 
                            
                                class="fa fa-trash fa-lg bg-gray 
                            
                                p-2 rounded text-danger pointer"
                                
                                (click)="remove_TempAccess(item,i)" 
                                
                                aria-hidden="true">
                            
                            </i>
    
                        </td>
                        
                        <td class="col-1 text-center"> {{ item.strFullDate | faNum }}</td>
    
                        <td class="col-1 text-center"> {{ item.strFullName | faNum }} </td>
    
                        <td class="col-1 text-center"> {{ item.strMobile | faNum }} </td>
    
                        <td class="col-1 text-center"> {{ item.strSDate | faNum }} </td>

                        <td class="col-1 text-center"> {{ item.strSTime | faNum }} </td>
    
                        <td class="col-1 text-center"> {{ item.strEDate | faNum }} </td>
        
                        <td class="col-1 text-center"> {{ item.strETime | faNum }} </td>
    
                        <td class="col-1 text-center"> {{ item.strLastUssFullDate | faNum }} </td>
    
                    </tr>
    
                </tbody>
        
            </table>

        </div>

    </section>

</main>

<!-- افزودن -->

<div class="modal fade" id="tempAccess-modal" tabindex="-1" aria-hidden="true" data-backdrop="false" data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-lg">
  
      <div class="modal-content p-1">
  
        <div class="modal-header dirI">
  
          <h5 class="modal-title"> {{ bEditMode ? 'ویرایش' : 'افزودن' }} دسترسی موقت </h5>
  
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
  
        </div>
  
        <div class="modal-body">

            <div [formGroup]="mdlTempAccess" class="row gx-3 gy-4 p-2 mb-2 justify-content-between rounded">

                <div class="position-relative col-md-6 col-12">

                    <label for="strFamily" class="text-danger">تاریخ شروع</label>

                    <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY-MM-DD'" [dateFormat]="'jYYYY/jMM/jDD'">

                         <input dir="ltr" type="text" formControlName="strSDate" class="form-control" >
                        
                    </ng-persian-datepicker>

                </div>

                <div class="position-relative col-md-6 col-12">

                    <label for="strFamily" class="text-danger">ساعت شروع</label>

                    <div class="input-group clockpicker">

                        <input type="text" class="form-control text-center" id="Stime" formControlName="strSTime">
                        
                        <span class="input-group-addon ">
                            
                            <span class="glyphicon glyphicon-time"></span>
                            
                        </span>
                        
                    </div>
                    
                </div>

                <div class="position-relative col-md-6 col-12">

                    <label for="strFamily" class="text-danger">تاریخ پایان</label>

                    <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY-MM-DD'" [dateFormat]="'jYYYY/jMM/jDD'">

                        <input dir="ltr" type="text" formControlName="strEDate" class="form-control" >
                       
                   </ng-persian-datepicker>

                </div>

                <div class="position-relative col-md-6 col-12">

                    <label for="strFamily" class="text-danger">ساعت پایان</label>

                    <div class="input-group clockpicker">

                        <input type="text" class="form-control text-center" id="Etime" formControlName="strETime">
                        
                        <span class="input-group-addon ">
                            
                            <span class="glyphicon glyphicon-time"></span>
                            
                        </span>
                        
                    </div>

                </div>
                
                <div class="position-relative col-md-6 col-12">

                    <label for="strFamily" class="text-danger">موبایل (کاربری)</label>

                    <input dir="ltr" type="text" maxlength="11" formControlName="strMobile" class="form-control" >

                </div>
                
                <div class="position-relative col-md-6 col-12">

                    <label for="strFamily" class="text-danger">رمز عبور</label>

                    <input dir="ltr" type="text" formControlName="strPassword" class="form-control" >

                </div>

            </div>

        </div>

        <div class="modal-footer">

            <div class="col-12 d-flex justify-content-start">

                <button class="btn px-4" [ngClass]="bEditMode ? 'btn-primary' : 'btn-success' " (click)="new_TempAccess()">

                    {{bEditMode ? 'ویرایش' : 'ذخیره' }}

                </button>

            </div>

        </div>
  
      </div>
  
    </div>
  
</div>

<!-- ارسال SMS -->

<div class="modal fade" id="tempSMS-modal" tabindex="-1" aria-hidden="true" data-backdrop="false" data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-md">
  
      <div class="modal-content p-1">
  
        <div class="modal-header dirI">
  
          <h5 class="modal-title"> پیامک لینک به موبایل کاربر  </h5>
  
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
  
        </div>
  
        <div class="modal-body">

            <div [formGroup]="mdlTempAccess" class="row gx-3 gy-4 p-2 mb-2 justify-content-between rounded">

                <div class="position-relative col-12">

                    <label for="strFamily" class="text-danger">شماره موبایل کاربر</label>

                    <input dir="ltr" type="text" maxlength="11" 
                    
                        oninput="this.value = this.value.replace(/[^0-9.]/g, '')"
                    
                        formControlName="strMobile" class="form-control" >

                </div>
                
            </div>

        </div>

        <div class="modal-footer">

            <div class="col-12 d-flex justify-content-start">

                <button class="btn btn-danger px-4" data-bs-dismiss="modal" aria-label="Close">

                    لغو

                </button>

                <button class="btn btn-success px-4 mx-2" (click)="send_SMS()">

                    ارسال

                </button>

            </div>

        </div>
  
      </div>
  
    </div>
  
</div>